/**
 * @Copyright 2014-2018 DataVoke, Inc. All rights reserved.
 */

/**
 * Class that handles any API methods related to the current user
 */
export class UserApi {

    /**
     * Return if the current user is a member of a specified security group.
     * @param {number|string|object} value - The SecurityGroupID, UID, or linker object of the security group to check for
     * @returns {boolean} True if the current user is a member of the specified group, false otherwise
     */
    isMemberOf(value) {
        return app.dv.cache.session.isMemberOf(value);
    }
}
